module.exports = __webpack_public_path__ + "img/1F1EA-1F1F7.d745ac74.svg";